module.exports = __webpack_public_path__ + "media/images/icons/cathedral-18a69b04393f58da9a59bfc59cf458cd.svg";